import { render, staticRenderFns } from "./tableField.vue?vue&type=template&id=2834ea74"
import script from "./tableField.vue?vue&type=script&lang=js"
export * from "./tableField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports